import { createContext, useContext } from 'react';
import { Layout } from '../../../queries/ats/layout/types';

export const SectionContext = createContext<Layout.SectionView | undefined>(undefined);

export function useSectionContext(name: string) {
  const context = useContext(SectionContext);

  if (!context) {
    throw new Error(`${name} tried to usePageContext outside of SectionContextProvider`);
  }

  return context;
}

interface SectionContextProviderProps {
  section: Layout.SectionView;
  children: React.ReactNode;
}

export function SectionContextProvider({ section, children }: SectionContextProviderProps) {
  return <SectionContext.Provider value={section}>{children}</SectionContext.Provider>;
}
